export const base = {
  breakpoints: ["768px"],
  fonts: {
    heading: "Poppins",
    body: "Poppins",
    general: "Poppins",
  },
  fontSizes: ["12px", "14px", "16px", "20px", "24px"],
};
